import React from 'react'
import {
  containsUpperCase,
  containsLowercase,
  containsNumber,
  containsSpecialCharachter
} from '../../../utils/functions'
import Checkbox from '@mui/material/Checkbox'
import PropTypes from 'prop-types'
import './PasswordCheck.scss'
import { useTranslation } from 'react-i18next'

export const PasswordCheck = ({ password, variant = 'light' }) => {
  const { t } = useTranslation()
  const [isUpperCase, setIsUpperCase] = React.useState(false)
  const [isLowerCase, setIsLowerCase] = React.useState(false)
  const [isNumberCase, setIsNumberCase] = React.useState(false)
  const [isSpecialCase, setIsSpecialCase] = React.useState(false)
  const isLight = variant !== 'dark'

  React.useEffect(() => {
    setIsUpperCase(containsUpperCase(password))
    setIsLowerCase(containsLowercase(password))
    setIsNumberCase(containsNumber(password))
    setIsSpecialCase(containsSpecialCharachter(password))
  }, [password])

  const requirements = [
    { checked: isUpperCase, label: t('Contains at least 1 upper case character') },
    { checked: isLowerCase, label: t('Contains at least 1 lower case character') },
    { checked: isNumberCase, label: t('Contains at least 1 number') },
    { checked: isSpecialCase, label: t('Contains at least 1 special character') }
  ]

  const textColor = isLight ? '#ffffff' : '#000000'
  const checkboxSx = isLight
    ? {
        color: 'rgba(255, 255, 255, 0.85) !important',
        padding: '4px 9px',
        '&.Mui-checked': { color: '#ffffff !important' },
        '&.Mui-disabled': { color: 'rgba(255, 255, 255, 0.7) !important' },
        '&.Mui-disabled.Mui-checked': { color: '#ffffff !important' },
        '& .MuiSvgIcon-root': { fill: 'currentColor' }
      }
    : { padding: '4px 9px' }

  return (
    <div
      className={`requirements ${isLight ? 'requirements--light' : 'requirements--dark'}`}
      data-password-check={isLight ? 'light' : 'dark'}
    >
      {requirements.map((item) => (
        <div className="requirement" key={item.label}>
          <Checkbox disabled checked={item.checked} sx={checkboxSx} />
          <p
            className="requirement__label"
            style={{
              color: textColor,
              WebkitTextFillColor: textColor,
              margin: 0,
              fontSize: '0.875rem'
            }}
          >
            {item.label}
          </p>
        </div>
      ))}
    </div>
  )
}

PasswordCheck.propTypes = {
  password: PropTypes.string,
  variant: PropTypes.oneOf(['light', 'dark'])
}
